/*
 * @Autor: fengqi
 * @Date: 2019-10-08 14:54:30
 * @LastEditors: fengqi
 * @LastEditTime: 2019-10-30 09:41:35
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('./views/success.vue')
    }
  ]
})
